import type { FaireProductEntity } from "../../entity_types/product";

export const p_h4u8js595b: FaireProductEntity = {
  token: "p_h4u8js595b",
  type: "product",
  name: "CHIPPYS — 100% Grass-Fed Beef Tallow Potato Chips",
  brandToken: "b_xpgzk3jdj5",
  brandName: "Chippys",
  imageUrl:
    "https://cdn.faire.com/fastly/407af9c3db68727eca9f6ff91e7bdf594b71340e856cc9484c2e09ff123d1d12.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f1cb5521f8361e3c8d3f3c8cad649d8379188ba5aa8c64550e3fdd0af33e8812.png",
  ],
  priceDollars: 5.49,
  description:
    "-Kettle-cooked in 100% grass-fed beef tallow for a rich, nostalgic crunch\n\n-Made in small batches from Non-GMO potatoes\n\n-Free from gluten, preservatives, artificial flavorings, and seed oils \n\n-Bold packaging with fun, happy branding that pops on shelves\n\n-Perfect for customers seeking better-for-you snacks without sacrificing flavor\n\n-Woman-owned and veteran-owned business\n",
  tags: [],
  msrpDollars: 11.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-05T05:28:15.965Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
